/*
 * The follow-up cards' form and its checks, after Android's FollowUpsForm
 * (followups/FollowUpsViewModel.kt). The invoice page (SQ-687 / SQ-688) uses
 * it; the cards are the same ones Android's estimate follow-ups page has.
 */

export const MAX_FOLLOW_UPS = 5;
export const MAX_DAYS = 60;

/** 0 (unset) through 60 days: a new card starts at 0, which is "not chosen". */
export const FOLLOW_UP_CHOICES = Array.from({length: MAX_DAYS + 1}, (_, i) => i);

/** One card. Text cannot be picked yet: the server only sends email. */
export interface FollowUpRow {
  days: number;
  text: boolean;
  email: boolean;
}

export interface FollowUpsForm {
  on: boolean;
  rows: FollowUpRow[];
}

/** Blank on purpose: nothing is saved that was never chosen. */
export const newFollowUpRow = (): FollowUpRow => ({days: 0, text: false, email: false});

/** Each follow-up has to land later than the one above it. */
export const badDays = (form: FollowUpsForm, i: number) =>
  form.rows[i].days <= (i === 0 ? 0 : form.rows[i - 1].days);

export const badMethod = (form: FollowUpsForm, i: number) => !form.rows[i].text && !form.rows[i].email;

/** The card's own wording, so the problem is stated where the fix happens. */
export const cardMessages = (form: FollowUpsForm, i: number): string[] => {
  const messages: string[] = [];
  if (badDays(form, i)) messages.push(i === 0 ? 'Pick how many days.' : `Needs more days than follow-up ${i}.`);
  // Text is not offered yet, so Email is the only way to fix it.
  if (badMethod(form, i)) messages.push('Check Email so this one goes out.');
  return messages;
};

/** Switched off, nothing is checked: the off state always saves. */
export const hasProblems = (form: FollowUpsForm) =>
  form.on && form.rows.some((_, i) => cardMessages(form, i).length > 0);

export const sameFollowUps = (a: FollowUpsForm, b: FollowUpsForm) =>
  a.on === b.on && a.rows.length === b.rows.length
  && a.rows.every((r, i) => r.days === b.rows[i].days && r.text === b.rows[i].text && r.email === b.rows[i].email);
